module.exports = __webpack_public_path__ + "img/coupon-item-invalid-bg.98b1e171.png";